const ViewTypes = {
  NORMAL: "NORMAL",
  MYGENE: "MYGENE",
  EDITED: "EDITED",
  SECOND_NORMAL: "SECOND_NORMAL",
  SECOND_MYGENE: "SECOND_MYGENE",
  SECOND_EDITED: "SECOND_EDITED",
} as const;

export type ViewType = (typeof ViewTypes)[keyof typeof ViewTypes];
// 全てのtypeを配列として取得
export const AllViewType = Object.values(ViewTypes);

export const isViewTypeForSecond = (
  vt: ViewType
): vt is "SECOND_NORMAL" | "SECOND_MYGENE" | "SECOND_EDITED" =>
  vt === "SECOND_NORMAL" || vt === "SECOND_MYGENE" || vt === "SECOND_EDITED";
